import * as strings from "../strings";

import {
	IconEco,
	IconSpeed,
	IconHwSeatbelt,
	IconHwBraking,
	IconHwAcceleration,
	IconHwCornering,
	IconHwExcessiveSpeed,
	IconHwSmoking,
	IconHwFoodAndDrink,
	IconHwCellPhoneUse,
	IconHwBackingAtStart,
	IconHwCloseFollowing,
} from "assets";

const per100KM = (value: any) =>
	value.mileage < 100_000
		? value.total
		: (value.total / (value.mileage / 1000)) * 100;

export const HW_PILLAR_SPEED = {
	type: "hw_speed",
	id: "hw_speed",
	icon: IconSpeed,
	calc: (value: any) => {
		return (value.total / value.engineEvents) * 100;
	},
	strings: {
		name: strings.PILLAR_HW_SPEED_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP,
		description: () => strings.PILLAR_HW_SPEED_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT_PLURAL,
		suffix: "%",
		fullName: strings.PILLAR_SPEED_FULL_NAME,
		fullNamePlural: strings.PILLAR_SPEED_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_SPEED_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_SPEED_TOOLTIP_TITLE,
			copy: strings.PILLAR_SPEED_TOOLTIP_COPY,
			fleet: strings.PILLAR_SPEED_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_SPEED_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "engineEvents",
		key: "hw_speed",
		stat: "hw_speed",
		benchmarkStat: "speed",
		boxplotKey: "hw_speed",
	},
};

export const HW_PILLAR_SEATBELT = {
	type: "hw_seatbelt",
	id: "hw_seatbelt",
	icon: IconHwSeatbelt,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_SEATBELT_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_SEATBELT_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_SEATBELT_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_seatbelt",
		stat: "hw_seatbelt",
		benchmarkStat: "hw_seatbelt",
		boxplotKey: "hw_seatbelt",
	},
};

export const HW_PILLAR_ACCELERATION = {
	type: "hw_acceleration",
	id: "hw_acceleration",
	icon: IconHwAcceleration,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_ACCELERATION_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_ACCELERATION_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_ACCELERATION_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_acceleration",
		stat: "hw_acceleration",
		benchmarkStat: "hw_acceleration",
		boxplotKey: "hw_acceleration",
	},
};

export const HW_PILLAR_BRAKING = {
	type: "hw_braking",
	id: "hw_braking",
	icon: IconHwBraking,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_BRAKING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_BRAKING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_BRAKING_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_braking",
		stat: "hw_braking",
		benchmarkStat: "hw_braking",
		boxplotKey: "hw_braking",
	},
};

export const HW_PILLAR_CORNERING = {
	type: "hw_cornering",
	id: "hw_cornering",
	icon: IconHwCornering,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_CORNERING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_CORNERING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_RISK_FULL_NAME,
		fullNamePlural: strings.PILLAR_RISK_FULL_NAME_PLURAL,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_CORNERING_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_RISK_TOOLTIP_TITLE,
			copy: strings.PILLAR_RISK_TOOLTIP_COPY,
			fleet: strings.PILLAR_RISK_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_RISK_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_cornering",
		stat: "hw_cornering",
		benchmarkStat: "hw_cornering",
		boxplotKey: "hw_cornering",
	},
};

export const HW_PILLAR_EXCESSIVE_SPEED = {
	type: "hw_excessive_speed",
	id: "hw_excessive_speed",
	icon: IconHwExcessiveSpeed,
	calc: (value: any) => {
		return (value.total / value.engineEvents) * 100;
	},
	strings: {
		name: strings.PILLAR_HW_EXCESSIVE_SPEED_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP,
		description: () => strings.PILLAR_HW_EXCESSIVE_SPEED_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT_PLURAL,
		suffix: "",
		fullName: strings.PILLAR_SPEED_FULL_NAME,
		fullNamePlural: strings.PILLAR_SPEED_FULL_NAME_PLURAL,
		xAxisTitle: (imperial: boolean) =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_EXCESSIVE_SPEED_NAME,
			}),
		tooltip: {
			title: strings.PILLAR_SPEED_TOOLTIP_TITLE,
			copy: strings.PILLAR_SPEED_TOOLTIP_COPY,
			fleet: strings.PILLAR_SPEED_TOOLTIP_FLEET_COPY,
			user: strings.PILLAR_SPEED_TOOLTIP_DRIVER_COPY,
		},
	},
	data: {
		averageBy: "engineEvents",
		key: "hw_excessive_speed",
		stat: "hw_excessive_speed",
		benchmarkStat: "speed",
		boxplotKey: "hw_excessive_speed",
	},
};

export const HW_PILLAR_ECO = {
	type: "hw_eco",
	id: "hw_eco",
	icon: IconEco,
	calc: per100KM,
	strings: {
		name: strings.PILLAR_ECO_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: (imperial: boolean) =>
			strings.PILLAR_ECO_DESCRIPTION.with({
				unit: imperial
					? strings.UNIT_62_MILES_SHORT
					: strings.UNIT_100_KILOMETERS_SHORT,
			}),
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		xAxisTitle: (imperial: boolean) =>
			strings.PILLAR_ECO_XAXIS_TITLE.with({
				unit: imperial
					? strings.UNIT_62_MILES_SHORT
					: strings.UNIT_100_KILOMETERS_SHORT,
			}),
		fullName: strings.PILLAR_ECO_FULL_NAME,
		fullNamePlural: strings.PILLAR_ECO_FULL_NAME_PLURAL,
		tooltip: {
			title: strings.PILLAR_ECO_TOOLTIP_TITLE,
			copy: strings.PILLAR_ECO_TOOLTIP_COPY,
			fleet: strings.MISC_EMPTY_STRING,
			user: strings.MISC_EMPTY_STRING,
		},
		viewSubPillars: strings.PILLAR_ECO_VIEW_BREAKDOWN,
	},
	data: {
		averageBy: "mileage",
		key: "hw_eco",
		stat: "hw_eco",
		benchmarkStat: "hw_eco",
		boxplotKey: "hw_eco",
	},
};

export const HW_PILLAR_SMOKING = {
	type: "hw_smoking",
	id: "hw_smoking",
	icon: IconHwSmoking,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_SMOKING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_SMOKING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_HW_SMOKING_NAME,
		fullNamePlural: strings.PILLAR_HW_SMOKING_NAME,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_SMOKING_NAME,
			}),
		tooltip: {
			title: "", // We don't need these as we don't show the tooltips in the UI for Geotab
			copy: "",
			fleet: "",
			user: "",
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_smoking",
		stat: "hw_smoking",
		benchmarkStat: "hw_smoking",
		boxplotKey: "hw_smoking",
	},
};

export const HW_PILLAR_FOOD_AND_DRINK = {
	type: "hw_food_and_drink",
	id: "hw_food_and_drink",
	icon: IconHwFoodAndDrink,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_FOOD_AND_DRINK_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_FOOD_AND_DRINK_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_HW_FOOD_AND_DRINK_NAME,
		fullNamePlural: strings.PILLAR_HW_FOOD_AND_DRINK_NAME,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_FOOD_AND_DRINK_NAME,
			}),
		tooltip: {
			title: "",
			copy: "",
			fleet: "",
			user: "",
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_food_and_drink",
		stat: "hw_food_and_drink",
		benchmarkStat: "hw_food_and_drink",
		boxplotKey: "hw_food_and_drink",
	},
};

export const HW_PILLAR_CELL_PHONE_USE = {
	type: "hw_cell_phone_use",
	id: "hw_cell_phone_use",
	icon: IconHwCellPhoneUse,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_CELL_PHONE_USE_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_CELL_PHONE_USE_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_HW_CELL_PHONE_USE_NAME,
		fullNamePlural: strings.PILLAR_HW_CELL_PHONE_USE_NAME,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_CELL_PHONE_USE_NAME,
			}),
		tooltip: {
			title: "",
			copy: "",
			fleet: "",
			user: "",
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_cell_phone_use",
		stat: "hw_cell_phone_use",
		benchmarkStat: "hw_cell_phone_use",
		boxplotKey: "hw_cell_phone_use",
	},
};

export const HW_PILLAR_BACKING_AT_START = {
	type: "hw_backing_at_start",
	id: "hw_backing_at_start",
	icon: IconHwBackingAtStart,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_BACKING_AT_START_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_BACKING_AT_START_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_HW_BACKING_AT_START_NAME,
		fullNamePlural: strings.PILLAR_HW_BACKING_AT_START_NAME,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_BACKING_AT_START_NAME,
			}),
		tooltip: {
			title: "",
			copy: "",
			fleet: "",
			user: "",
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_backing_at_start",
		stat: "hw_backing_at_start",
		benchmarkStat: "hw_backing_at_start",
		boxplotKey: "hw_backing_at_start",
	},
};

export const HW_PILLAR_CLOSE_FOLLOWING = {
	type: "hw_close_following",
	id: "hw_close_following",
	icon: IconHwCloseFollowing,
	calc: per100KM,
	tooltipIndex: 0,
	strings: {
		name: strings.PILLAR_HW_CLOSE_FOLLOWING_NAME,
		benchmarkTooltip: strings.PILLAR_BENCHMARK_TOOLTIP_EVENTS,
		description: () => strings.PILLAR_HW_CLOSE_FOLLOWING_SCORE,
		unitPlural: strings.PILLAR_UNIT_EVENT_PLURAL,
		unit: strings.PILLAR_UNIT_EVENT,
		suffix: "",
		fullName: strings.PILLAR_HW_CLOSE_FOLLOWING_NAME,
		fullNamePlural: strings.PILLAR_HW_CLOSE_FOLLOWING_NAME,
		xAxisTitle: () =>
			strings.HW_PILLAR_XAXIS_TITLE.with({
				pillar: strings.PILLAR_HW_CLOSE_FOLLOWING_NAME,
			}),
		tooltip: {
			title: "",
			copy: "",
			fleet: "",
			user: "",
		},
	},
	data: {
		averageBy: "mileage",
		key: "hw_close_following",
		stat: "hw_close_following",
		benchmarkStat: "hw_close_following",
		boxplotKey: "hw_close_following",
	},
};

export const PILLARS = [
	HW_PILLAR_SPEED,
	HW_PILLAR_EXCESSIVE_SPEED,
	HW_PILLAR_SEATBELT,
	HW_PILLAR_ACCELERATION,
	HW_PILLAR_BRAKING,
	HW_PILLAR_CORNERING,
	HW_PILLAR_SMOKING,
	HW_PILLAR_FOOD_AND_DRINK,
	HW_PILLAR_CELL_PHONE_USE,
	HW_PILLAR_BACKING_AT_START,
	HW_PILLAR_CLOSE_FOLLOWING,
	HW_PILLAR_ECO,
];
